<template>
  <div class="user_layout">
    <div class="layout_center">
      <div class="center_back"></div>
      <a-card class="center_card">
        <router-view />
      </a-card>
    </div>
  </div>
</template>

<script>
// import RouteView from './RouteView'
// import { mixinDevice } from '@/utils/mixin'

export default {
  name: 'UserLayout',
  // components: { RouteView },
  // mixins: [mixinDevice],
  data() {
    return {}
  },
  mounted() {
    // document.body.classList.add('userLayout')
  },
  beforeDestroy() {
    // document.body.classList.remove('userLayout')
  }
}
</script>

<style lang="less" scoped>
.user_layout {
  height: 100%;
  min-height: 658px;
  background-color: #fff;
  overflow: hidden;
  .layout_center {
    width: 1200px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .center_back {
      width: 651px;
      height: 408px;
      background-image: url(~@/assets/Thesis-bro.png);
      background-size: cover;
    }
    .center_card {
      width: 490px;
      margin: 12px 0;
      box-shadow: 0px 9px 28px 20px rgba(0, 0, 0, 0.04);
      border-radius: 15px;
      /deep/.ant-card-body {
        padding: 38px 46px 16px;
      }
    }
  }
}
</style>
